






import { Vue, Component } from 'vue-property-decorator';

import { invertedLogo } from '@/assets/images';
import { BASE_ROUTES } from '@/constants/routes';

@Component
export default class Logo extends Vue {
  public logo: string = invertedLogo;

  public handleClick() {
    this.$router.push({
      path: BASE_ROUTES.HOME
    });
  }
}
